import { PersonalData } from "./contact/personal-data";
import { ProductForCreateOrderRequest } from "./product-for-create-order-request";
import { DeliveryData } from "./typeofdelivery/delivery";
import { PaymentOption } from "./typeofpayment/billing-options";

export class CreateOrderRequest {
    personalData?: PersonalData;
    deliveryData?: DeliveryData;
    products?: ProductForCreateOrderRequest[];
    totalPriceOfBooks?: number;
    totalPrice?: number;
    subscribedForNewsletter?: boolean;
    paymentOption?: string;
    language?:string;
    clientId?:string;
    separated?:boolean;
}
